import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield } from 'lucide-react';
const CART_URL = 'https://omanualproibido.com.br/oferta-especial/?funnel=fn26a5a0d6&step=86&actionId=565400&currentStepId=446780&previousStepId=446768&rda=false&referrer=https%3A%2F%2Fwww.facebook.com%2F';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className={`fixed left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-primary/95 backdrop-blur-md border-b border-white/5 py-3' : 'bg-transparent py-4'}`} style={{
    top: '36px'
  }} data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex justify-between items-center" data-id="element-77">
        <div className="flex items-center gap-2" data-id="element-78">
          <Shield size={20} className="text-crimson" data-id="element-79" />
          <span className="text-white font-black text-sm sm:text-base tracking-wider uppercase" data-id="element-80">
            Manual <span className="text-crimson" data-id="element-81">Prohibido</span>
          </span>
        </div>

        <motion.a href={CART_URL} target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0
      }} animate={{
        opacity: scrolled ? 1 : 0
      }} className={`bg-crimson hover:bg-crimson-light text-white font-bold py-2 px-5 rounded text-xs sm:text-sm transition-colors duration-300 uppercase tracking-wider ${scrolled ? 'pointer-events-auto' : 'pointer-events-none'}`} data-id="element-82">
          ¡Lo quiero!
        </motion.a>
      </div>
    </motion.nav>;
}